import React, { useEffect, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, message, Spin, Upload } from "antd";
import { getSign } from "@/services/auth";
import axios from "axios";
//语言切换
import intl from "react-intl-universal";
// fileList: 文件列表
// onChange: 事件回调
// fileType: 文件格式/title  1 pdf、word   5 pdf
// isLimted: 文件大小限制
// maxCount: 最大上传数量
// multiple: 是否多选
// disabled: 是否禁用
// upLoadButtonName: 上传文件按钮名字
export default function AliyunOSSUpload({
  fileList,
  callBack,
  fileType, // 1 绿通 2 附件 3 签署文件  4 作废凭证  5 PDF  6 doc、docx、pdf、ppt、zip、rar、jpg、jpeg、png、gif 100 jpg、jpeg、png、gif、PDF
  isLimted,
  maxCount,
  multiple,
  showUploadList,
  disabled,
  accept,
  children,
  ossData,
  upLoadButtonName = intl.get(
    "Click_to_Upload_a616d5f5-2d5d-28fa-a73b-62a936d45a50"
  ),
  first, // 上传一级目录
  second, //  上传二级目录
}) {
  const [OSSData, setOSSData] = useState(ossData);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    if (!OSSData) {
      init();
    }
  }, []);

  // 初始化
  const init = async () => {
    try {
      const res = await getSign(first, second); // 获取签名
      if (res.code === 0) {
        setOSSData(res.data);
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error);
    }
  };

  const handleChange = ({ fileList }) => {
    const tempFileList = [...uploadFileList];
    fileList.map((file) => {
      if (uploadFileList.filter((item) => item.uid === file.uid).length === 0) {
        tempFileList.push(file);
      }
    });
    setUploadFileList(tempFileList);
  };

  // 删除列表
  const onRemove = (file) => {
    const files = (fileList || []).filter((v) => v.url !== file.url);
    setUploadFileList(fileList);
    if (callBack) {
      callBack(files, fileType);
    }
  };

  const onPreview = (file) => {
    getBlob(file.url, function (blob) {
      saveAs(blob, file.name);
    });
  };

  const getExtraData = (file) => ({
    key: file.url,
    OSSAccessKeyId: OSSData?.accessId,
    policy: OSSData?.policy,
    Signature: OSSData?.signature,
  });

  const beforeUpload = async (file) => {
    if (!OSSData) return false;
    if (uploadFileList.length >= maxCount) {
      message.warn(
        intl.get("93b1e8bc-d225-2655-95a9-1433e339586b", { count: maxCount })
      );
      return false;
    }
    if (fileType == 1) {
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type === "message/rfc822" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType == 2) {
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/zip" || // mac-OS
        file.type === "application/x-zip-compressed" || // windows
        file.type === "";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType == 3) {
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType == 4) {
      const isJpgOrPng = file.type === "message/rfc822";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType == 5) {
      const isJpgOrPng = file.type === "application/pdf";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType == 6) {
      // doc、docx、pdf、ppt、zip、rar、jpg、jpeg、png、gif
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type === "message/rfc822" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/zip" || // mac-OS
        file.type === "application/x-zip-compressed" || // windows
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType === 7) {
      // jpg、jpeg、png、gif、3gp、MP4、mpeg、mov、aac、mp3、wav
      const isJpgOrPng =
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "video/3gpp" ||
        file.type === "video/mp4" ||
        file.type === "video/mpeg" ||
        file.type === "video/quicktime" ||
        file.type === "audio/aac" ||
        file.type === "audio/mpeg" ||
        file.type === "audio/vnd.dlna.adts" ||
        file.type === "audio/wav";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType === 8) {
      const extraItem =
        file.type === "application/pdf" ||
        file.type === "text/plain" ||
        file.type === "video/mp4" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "audio/wav" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";

      if (!extraItem) {
        message.error(intl.get("up-c8ab8883-4c75-20cf-a2d7-0b54636044d9"));
        return Upload.LIST_IGNORE;
      }
    } else if (fileType === 9) {
      // jpg、jpeg、png、gif、aac、mp3、wav
      const isJpgOrPng =
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "audio/aac" ||
        file.type === "audio/vnd.dlna.adts" ||
        file.type === "audio/mpeg" ||
        file.type === "audio/wav";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType === 10) {
      const isAudio = file.type === "audio/wav";

      if (!isAudio) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    } else if (fileType === 100) {
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";

      if (!isJpgOrPng) {
        message.error(
          intl.get("Upload_77cc2d03-5292-2c36-9676-5ae37506beb9_Upload")
        );
        return Upload.LIST_IGNORE;
      }
    }

    const isLimte = file.size / 1024 / 1024 < isLimted;
    if (!isLimte) {
      let messMess = "";
      if (
        (localStorage.getItem("language_type") &&
          localStorage.getItem("language_type") == "zh_CN") ||
        !localStorage.getItem("language_type")
      ) {
        messMess = `${intl.get("7fe8960b-7cb5-2ce7-8ff2-eb8b5d459ca1", {
          size: isLimted,
        })}`;
      } else if (
        localStorage.getItem("language_type") &&
        localStorage.getItem("language_type") == "en_US"
      ) {
        messMess = `${intl.get("7fe8960b-7cb5-2ce7-8ff2-eb8b5d459ca1", {
          size: isLimted,
        })}`;
      }

      message.error(messMess);
      return Upload.LIST_IGNORE;
    }

    const expire = Number(OSSData.expire) * 1000;
    if (expire < Date.now()) {
      await init();
    }
    const suffix = file.name.slice(file.name.lastIndexOf("."));
    const filename = Date.now() + suffix;
    // @ts-ignore
    file.url = OSSData.dir + "/" + filename;
    return file;
  };

  const getBlob = (url, cb) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  };

  const saveAs = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      var body = document.querySelector("body");

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      // fix Firefox
      link.style.display = "none";
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  };

  let a = [];
  function customRequest(option) {
    const { file, data, action } = option;
    setSpinning(true);
    // 这里使用 axios 作为请求库，你可以根据实际情况替换为你的请求库
    const formData = new FormData();
    formData.append("key", data.key);
    formData.append("OSSAccessKeyId", data.OSSAccessKeyId);
    formData.append("policy", data.policy);
    formData.append("Signature", data.Signature);
    formData.append("file", file);
    axios
      .post(action, formData)
      .then((response) => {
        if (file.url.indexOf(OSSData.host) == -1) {
          a.push({
            name: file.name,
            url: OSSData.host + "/" + file.url,
            type: file.type,
            lastModified: file.lastModified,
          });
        } else {
          a.push({
            name: file.name,
            url: file.url,
            type: file.type,
            lastModified: file.lastModified,
          });
        }

        let content = [];
        if (fileList && fileList.length != 0) {
          content = [...a, ...fileList];
        } else {
          content = [...a];
        }
        callBack?.(content, fileType);
      })
      .catch((error) => {
        message.error("上传失败，请重新上传");
        return;
      })
      .finally(() => {
        setSpinning(false);
      });
  }

  const uploadProps = {
    name: "file",
    fileList,
    action: OSSData?.host,
    onChange: handleChange,
    customRequest: customRequest,
    onRemove,
    data: getExtraData,
    beforeUpload,
    onPreview,
    maxCount,
    showUploadList: showUploadList,
    multiple: multiple,
    disabled: disabled,
    accept: accept,
  };

  return (
    <Upload {...uploadProps} disabled={spinning}>
      {fileList?.length >= maxCount ? null : children ? (
        <Spin spinning={spinning}>{children}</Spin>
      ) : (
        <Button icon={<UploadOutlined />} disabled={disabled}>
          {upLoadButtonName}
        </Button>
      )}
    </Upload>
  );
}
